import Vue from 'vue'
import Dialog from './dialog'

function popup (props) {
	const _props = props || {}

    const Instance = new Vue({
        render (h) {
            return h(Dialog, {
                props: _props
            })
        }
    })

    const component = Instance.$mount()
    document.body.appendChild(component.$el)

    return Instance.$children[0]
}

export default {
	name: 'Popup',
	open (options) {
		popup(options)
	}
}


// WEBPACK FOOTER //
// ./src/components/dialog/index.js